<script>
export default {
  name: 'MenuSignature'
}
</script>
<style lang="sass">

    @import ../../../common/styles/settings

    .menu-signature
        padding: $baseline 0
        background-color: white
        font-weight: 400

        +media('<=small')
            text-align: center
        +media('>small')
            display: flex
            justify-content: space-between

        p
            +media('<=small')
                margin-bottom: $baseline*.5

        ul
            margin: 0
            padding: 0
            list-style: none
            line-height: 1.375

            li
                display: inline-block

                + li
                    margin-left: $baseline*.125
                    padding-left: $baseline*.25
                    border-left: 1px solid $color-base

                    +media('>small')
                        margin-left: $baseline
                        padding-left: $baseline

                .one-trust-settings-button
                    cursor: pointer


</style>

